
import { Component } from "vue-property-decorator";
import SecurityService from "frontend-domain/src/domain/security/SecurityService";
import User from "frontend-domain/src/domain/security/SecuyrityEntities";
import BaseComponent from "../../BaseComponent";

@Component({ components: {} })
export default class LoginPage extends BaseComponent {
    user = new User();
    segService = new SecurityService();

    async logar() {
        await this.segService.logar(this.user);
        this.$emit("logged", true);
    }
}
